/* ============================================================================
   kitsters-press-page.js - Press & Media
   Owns exactly one behaviour: the "Copy boilerplate" button.

   Journalists want the paragraph, not a hand-retyped version of it, so the copy
   has to land on the clipboard verbatim. navigator.clipboard is unavailable on
   insecure origins and can be permission-denied, so the execCommand path stays
   as a fallback rather than letting the button silently do nothing.
   ========================================================================== */
(function () {
  'use strict';

  function textOf(el) {
    // innerText, not textContent: the boilerplate is richtext and may hold more
    // than one <p>. textContent would run them together with no separator.
    return (el.innerText || el.textContent || '').trim();
  }

  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-1000px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (e) {
      ok = false;
    }
    document.body.removeChild(ta);
    return ok;
  }

  function flash(btn, done) {
    var label = btn.querySelector('.kprs__copy-label');
    var idle = btn.getAttribute('data-label-idle') || 'Copy';
    var text = done
      ? btn.getAttribute('data-label-done') || 'Copied'
      : 'Press Ctrl+C to copy';

    if (label) label.textContent = text;
    btn.classList.toggle('is-copied', !!done);

    window.clearTimeout(btn._kprsTimer);
    btn._kprsTimer = window.setTimeout(function () {
      if (label) label.textContent = idle;
      btn.classList.remove('is-copied');
    }, 2400);
  }

  function bind(btn) {
    if (btn.dataset.kprsBound === '1') return;
    btn.dataset.kprsBound = '1';

    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('data-copy-target'));
      if (!target) return;
      var text = textOf(target);
      if (!text) return;

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(
          function () { flash(btn, true); },
          function () { flash(btn, legacyCopy(text)); }
        );
      } else {
        flash(btn, legacyCopy(text));
      }
    });
  }

  function init() {
    // Bound at document level, not against a section root: the press page is a
    // stack of sibling <section>s inside one wrapper, and a future split into
    // separate Shopify sections would break any root-scoped lookup
    // (CLAUDE.md §10.35).
    var buttons = document.querySelectorAll('[data-kprs-copy]');
    for (var i = 0; i < buttons.length; i++) bind(buttons[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', init);
})();
